import React from 'react';

import {cx} from '../util';

const CountLabel = ({count, active}) => (
  <span className={cx(
    'hidden border border-gray-300 ml-1.5 py-0.5 px-1 rounded-md text-xs font-medium md:inline-block',
    active
      ? 'bg-transparent text-indigo-600'
      : 'bg-gray-100 text-gray-600',
  )}
  >
    {count}
  </span>
);

export const Tab = ({
  active, onClick, count, children, disabled, id, controls, href,
}) => {
  const className = cx(
    'border-b-2 py-3 transition-colors',
    active ? 'border-indigo' : 'border-transparent',
  );

  const inner = (
    <div
      className={cx(
        active
          ? 'bg-indigo-50 text-indigo-700'
          : 'bg-gray-50 text-gray-500 hover:text-gray-700 hover:bg-gray-100',
        'whitespace-nowrap py-1.5 px-3 rounded-lg font-medium text-sm',
      )}
    >
      {children}
      {typeof count === 'number' && <CountLabel count={count} active={active} />}
    </div>
  );

  if (href) {
    return (
      <a
        href={href}
        onClick={(e) => {
          e.preventDefault();
          if (onClick) onClick();
        }}
        id={id}
        role="tab"
        aria-selected={active}
        aria-controls={controls}
        className={className}
      >
        {inner}
      </a>
    );
  }

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      id={id}
      role="tab"
      aria-selected={active}
      aria-controls={controls}
      className={className}
    >
      {inner}
    </button>
  );
};

export const Tabs = ({
  tabs, active, onClick, className, label = 'Tabs', useAnchor, noBorder,
}) => (
  <div className={cx(!noBorder && 'border-b border-gray-200', className)}>
    <div className="-mb-px -mx-4 px-4 flex space-x-3 overflow-x-auto scrollbar-hidden" role="tablist" aria-label={label}>
      {tabs.map((tab) => (
        <Tab
          key={tab.key}
          onClick={() => onClick(tab.key)}
          active={active === tab.key}
          count={tab.count}
          id={`tab-${tab.key}`}
          controls={`tabpanel-${tab.key}`}
          href={useAnchor ? tab.path : undefined}
        >
          {tab.label}
        </Tab>
      ))}
    </div>
  </div>
);
